import { defineMessages } from 'react-intl';
export default defineMessages({
  PaySuccessRetailtableType: {
    id: 'PaySuccessRetail.tableType',
    defaultMessage: '桌台类型',
  },
  PaySuccessRetailchooseTableType: {
    id: 'PaySuccessRetail.chooseTableType',
    defaultMessage: '请选择桌台类型',
  },
  PaySuccessRetailnoTableInfo: {
    id: 'PaySuccessRetail.noTableInfo',
    defaultMessage: '没有桌台信息',
  },
  PaySuccessRetailadvanceNow: {
    id: 'PaySuccessRetail.advanceNow',
    defaultMessage: '立即预订',
  },
  PaySuccessRetailPayAdvance: {
    id: 'PaySuccessRetail.PayAdvance',
    defaultMessage: '支付{currency}{payPrice}预付金',
  },
  PaySuccessRetailadvancedTime: {
    id: 'PaySuccessRetail.advancedTime',
    defaultMessage: '预订时间',
  },
  PaySuccessRetailnoSelectAbleInterval: {
    id: 'PaySuccessRetail.noSelectAbleInterval',
    defaultMessage: '已无可选时段',
  },
  PaySuccessRetailnoAdvancedTable: {
    id: 'PaySuccessRetail.noAdvancedTable',
    defaultMessage: '无可预订桌台',
  },
  PaySuccessRetailbookNumberOfPeople: {
    id: 'PaySuccessRetail.bookNumberOfPeople',
    defaultMessage: '预订人数',
  },
  PaySuccessRetailconnectWays: {
    id: 'PaySuccessRetail.connectWays',
    defaultMessage: '联系方式',
  },
  PaySuccessRetailinputPs: {
    id: 'PaySuccessRetail.inputPs',
    defaultMessage: '请输入备注...',
  },
  PaySuccessRetailbooInfo: {
    id: 'PaySuccessRetail.booInfo',
    defaultMessage: '预订信息',
  },
  PaySuccessRetailadvancedMoneyPrompt: {
    id: 'PaySuccessRetail.advancedMoneyPrompt',
    defaultMessage: '预付金可在消费时直接抵扣消费金额，若需要退预付金请联系门店协商',
  },
  PosLoginApplicationVipDisabledPrompt: {
    id: 'PosLoginApplication.VipDisabledPrompt',
    defaultMessage: '您的会员身份已被停用，当前无法登录，请联系商户',
  },
  PosLoginApplicationlogOnShopDevice: {
    id: 'PosLoginApplication.logOnShopDevice',
    defaultMessage: '即将授权在商户设备登录',
  },
  PosLoginApplicationconfirmLogin: {
    id: 'PosLoginApplication.confirmLogin',
    defaultMessage: '确认授权登录',
  },
  PosLoginApplicationReason: {
    id: 'PosLoginApplication.Reason',
    defaultMessage: '原因：',
  },
  PosLoginApplicationgotoShopIndex: {
    id: 'PosLoginApplication.gotoShopIndex',
    defaultMessage: '去门店首页看看',
  },
  PosLoginApplicationScanAgain: {
    id: 'PosLoginApplication.ScanAgain',
    defaultMessage: '重新扫码',
  },
  QueueCheckOrderApplicationSelected: {
    id: 'QueueCheckOrderApplication.Selected',
    defaultMessage: '已选商品',
  },
  QueueCheckOrderApplicationTotal: {
    id: 'QueueCheckOrderApplication.Total',
    defaultMessage: '共{count}份',
  },
  QueueCheckOrderApplicationinputPS: {
    id: 'QueueCheckOrderApplication.inputPS',
    defaultMessage: '在这里输入备注哦',
  },
  QueueDetailApplicationWaitingBeforeYou: {
    id: 'QueueDetailApplication.WaitingBeforeYou',
    defaultMessage: '在您之前还有{count}桌客人等候',
  },
  QueueDetailApplicationexpectWaitingTime: {
    id: 'QueueDetailApplication.expectWaitingTime',
    defaultMessage: '预计排队时间',
  },
  QueueDetailApplicationcallPrompt: {
    id: 'QueueDetailApplication.callPrompt',
    defaultMessage: '听到叫号请到迎宾台，过号作废',
  },
  QueueDetailApplicationcancelWait: {
    id: 'QueueDetailApplication.cancelWait',
    defaultMessage: '取消排队',
  },
  QueueDetailApplicationconfirmCancelWait: {
    id: 'QueueDetailApplication.confirmCancelWait',
    defaultMessage: '是否取消排队？',
  },
  QueueDetailApplicationLetMeSee: {
    id: 'QueueDetailApplication.LetMeSee',
    defaultMessage: '容我想想',
  },
  QueueDetailApplicationDecideToGo: {
    id: 'QueueDetailApplication.DecideToGo',
    defaultMessage: '去意已决',
  },
  RedirectApplicationGetConfigFaild: {
    id: 'RedirectApplication.GetConfigFaild',
    defaultMessage: '获取配置信息失败，请重试',
  },
  RedirectApplicationregisterOnlineDisabled: {
    id: 'RedirectApplication.registerOnlineDisabled',
    defaultMessage: '当前商户不支持线上注册，请联系服务员注册会员',
  },
  RedirectApplicationinputName: {
    id: 'RedirectApplication.inputName',
    defaultMessage: '请填写姓名',
  },
  RedirectApplicationinputSixDigitPW: {
    id: 'RedirectApplication.inputSixDigitPW',
    defaultMessage: '请输入6位数字密码',
  },
  RedirectApplicationinputPW: {
    id: 'RedirectApplication.inputPW',
    defaultMessage: '请填写交易密码',
  },
  RedirectApplicationChecked: {
    id: 'RedirectApplication.Checked',
    defaultMessage: '验证完毕，请稍后……',
  },
  RedirectApplicationmodifyBirthPrompt: {
    id: 'RedirectApplication.modifyBirthPrompt',
    defaultMessage: '注：生日不可修改，请谨慎填写。',
  },
  RegisterValidateApplicationreFresh: {
    id: 'RegisterValidateApplication.reFresh',
    defaultMessage: '接口请求失败，请刷新重试',
  },
  RegisterValidateApplicationPNisBound: {
    id: 'RegisterValidateApplication.PNisBound',
    defaultMessage: '该手机号已与其他微信号绑定，请使用其他手机号注册',
  },
  BindPhoneApplicationPN: {
    id: 'BindPhoneApplication.PN',
    defaultMessage: '手机号',
  },
  RewardApplicationReciveYourTip: {
    id: 'RewardApplication.ReciveYourTip',
    defaultMessage: '已收到您的打赏',
  },
  RegisterValidateApplicationthanksInfo: {
    id: 'RegisterValidateApplication.thanksInfo',
    defaultMessage: '感谢您的认可，顾客的满意是我们最大的幸福',
  },
  RegisterValidateApplicationGive: {
    id: 'RegisterValidateApplication.Give',
    defaultMessage: '赠送',
  },
  UserLoginApplicationLoginWithThirdPart: {
    id: 'UserLoginApplication.LoginWithThirdPart',
    defaultMessage: '第三方登录',
  },
  UserLoginApplicationLogin: {
    id: 'UserLoginApplication.Login',
    defaultMessage: '登录',
  },
  UserLoginApplicationgotoMeCenterToBind: {
    id: 'UserLoginApplication.gotoMeCenterToBind',
    defaultMessage: '如果已有手机号注册的账号，选择{value}登录后，请在个人中心绑定手机号，以便关联原有账户信息',
  },
  UserLoginApplicationAutoRegister: {
    id: 'UserLoginApplication.AutoRegister',
    defaultMessage: '如果您的手机号尚未注册，登录后将自动生成账号。',
  },
  UserLoginApplicationView:{
    id: 'UserLoginApplication.View',
    defaultMessage: '我已阅读并同意',
  },
  UserLoginApplicationClause: {
    id: 'UserLoginApplication.Clause',
    defaultMessage: '《客如云用户服务协议》和《客如云隐私政策》',
  },
  UserLoginApplicationPrivacyPolicy: {
    id: 'UserLoginApplication.PrivacyPolicy',
    defaultMessage: '《隐私政策》',
  },
  UserLoginApplicationServiceAgreement: {
    id: 'UserLoginApplication.ServiceAgreement',
    defaultMessage: '《用户服务协议》',
  },
  UserLoginApplicationAnd: {
    id: 'UserLoginApplication.And',
    defaultMessage: '和',
  },
  UserLoginApplicationWelcome: {
    id: 'UserLoginApplication.Welcome',
    defaultMessage: '欢迎来到',
  },
  UserLoginApplicationbecameVip: {
    id: 'UserLoginApplication.becameVip',
    defaultMessage: '恭喜您成为本店会员',
  },
  UserLoginApplicationdefaultPW: {
    id: 'UserLoginApplication.defaultPW',
    defaultMessage: '初始交易密码默认为手机号后六位',
  },
  UserLoginApplicationiKnown: {
    id: 'UserLoginApplication.iKnown',
    defaultMessage: '我知道了',
  },
  ActivateValidateApplicationGoodAt: {
    id: 'ActivateValidateApplication.GoodAt',
    defaultMessage: '拿手菜',
  },
  CookApplicationIsSoldOut: {
    id: 'CookApplication.IsSoldOut',
    defaultMessage: '已售{saleCount}份',
  },
  TackoutTrackApplicationBack: {
    id: 'TackoutTrackApplication.Back',
    defaultMessage: '返回',
  },
  TackoutTrackApplicationDeliveryId: {
    id: 'TackoutTrackApplication.DeliveryId',
    defaultMessage: '配送单号',
  },
  TackoutTrackApplicationExpected: {
    id: 'TackoutTrackApplication.Expected',
    defaultMessage: '预计',
  },
  TackoutTrackApplicationArrivals: {
    id: 'TackoutTrackApplication.Arrivals',
    defaultMessage: '到达',
  },
  TackoutTrackApplicationSend: {
    id: 'TackoutTrackApplication.Send',
    defaultMessage: '送达',
  },
  TackoutTrackSendDinner: {
    id: 'TackoutTrackApplication.SendDinner',
    defaultMessage: '骑手正在送餐',
  },
  TackoutTrackOnTheWay: {
    id: 'TackoutTrackApplication.OnTheWay',
    defaultMessage: '骑手正在路上',
  },
  TackoutTrackDistance: {
    id: 'TackoutTrackApplication.Distance',
    defaultMessage: '距您',
  },
  TackoutTrackMinutes: {
    id: 'TackoutTrackApplication.Minutes',
    defaultMessage: '分钟',
  },
  PosLoginApplicationLoginSuccess: {
    id: 'PosLoginApplication.LoginSuccess',
    defaultMessage: '授权登录成功',
  },
  PosLoginApplicationLoginFailed: {
    id: 'PosLoginApplication.LoginFailed',
    defaultMessage: '授权登录失败',
  },
  RegisterMemberApplicationUsername: {
    id: 'RegisterMemberApplication.username',
    defaultMessage: '方便我们称呼您',
  },
  RegisterMemberApplicationEnjoyBirthday: {
    id: 'RegisterMemberApplication.enjoyBirthday',
    defaultMessage: '享受生日专属福利',
  },
  RegisterMemberApplicationtransactionPWD: {
    id: 'RegisterMemberApplication.transactionPWD',
    defaultMessage: '交易密码',
  },
  RegisterMemberApplicationPWDPlaceholder: {
    id: 'RegisterMemberApplication.PWDPlaceholder',
    defaultMessage: '请为余额支付设置6位数字密码',
  },
  RegisterMemberApplicationhasCardNum: {
    id: 'RegisterMemberApplication.hasCardNum',
    defaultMessage: '我有卡号(可不填写)',
  },
  RegisterMemberApplicationcardIsCheck: {
    id: 'RegisterMemberApplication.cardIsCheck',
    defaultMessage: '卡号已通过验证',
  },
  RegisterMemberApplicationregisterMember: {
    id: 'RegisterMemberApplication.registerMember',
    defaultMessage: '申请会员',
  },
  RegisterMemberApplicationSelectBookTime: {
    id: 'RegisterMemberApplication.SelectBookTime',
    defaultMessage: '选择预订时间',
  },
  QueueDetailApplicationpeople: {
    id: 'QueueDetailApplication.people',
    defaultMessage: '{count}人',
  },
  QueueDetailApplicationmorePeople: {
    id: 'QueueDetailApplication.morePeople',
    defaultMessage: '{count}人以上',
  },
  QueueDetailApplicationmen: {
    id: 'QueueDetailApplication.men',
    defaultMessage: '先生',
  },
  QueueDetailApplicationlady: {
    id: 'QueueDetailApplication.lady',
    defaultMessage: '女士',
  },
  QueueDetailApplicationanonymousUser: {
    id: 'QueueDetailApplication.anonymousUser',
    defaultMessage: '匿名用户',
  },
  QueueDetailApplicationantable: {
    id: 'QueueDetailApplication.table',
    defaultMessage: '桌',
  },
  QueueDetailApplicationcomingSoon: {
    id: 'QueueDetailApplication.comingSoon',
    defaultMessage: '即将到号',
  },
  QueueDetailApplicationaboutTime: {
    id: 'QueueDetailApplication.aboutTime',
    defaultMessage: '大约{count}分钟',
  },
  QueueDetailApplicationtakeOrder: {
    id: 'QueueDetailApplication.takeOrder',
    defaultMessage: '取号',
  },
  userLoginPNLoginPrompt: {
    id: 'userLoginPNLoginPrompt',
    defaultMessage: '如果已有手机号注册的账号，选择{text}登录后，',
  },
  userLoginBindPNAfterLogin: {
    id: 'userLoginBindPNAfterLogin',
    defaultMessage: '请在个人中心绑定手机号，以便关联原有账户信息',
  },
  userLoginBindPNToOrder: {
    id: 'userLoginBindPNToOrder',
    defaultMessage: '绑定手机开始点餐',
  },
  userLoginDefaultPW: {
    id: 'userLoginDefaultPW',
    defaultMessage: '初始交易密码默认为',
  },
  userLoginSixDigRePN: {
    id: 'userLoginSixDigRePN',
    defaultMessage: '手机号后6位',
  },
  orderMemo: {
    id: 'orderMemo',
    defaultMessage: '订单备注',
  },
  noTouchMemoTip: {
    id: 'noTouchMemoTip',
    defaultMessage: '请从快捷备注中选择无接触配送',
  },
  orderQuickMemo: {
    id: 'orderQuickMemo',
    defaultMessage: '快捷备注: ',
  },
  inputOrderTip: {
    id: 'inputOrderTip',
    defaultMessage: '请填写您的备注',
  },
  warmTip: {
    id: 'warmTip',
    defaultMessage: '温馨提示',
  },
  getYourLocation: {
    id: 'getYourLocation',
    defaultMessage: '申请获取你的位置信息，你的位置信息将用于小程序位置接口的信息展示',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/container/part6/index.js